import React from "react";
import { AtSignIcon as InstagramIcon, MailIcon, MessageCircleIcon } from "lucide-react";
import { offer } from "../data/offer";
export function Footer() {
  const year = new Date().getFullYear();
  return <footer className="bg-forest-deep pb-28 pt-12 text-sm text-haze md:pb-12" data-id="element-115" data-mp="32onl753ftsa0">
      <div className="wrap flex flex-col justify-between gap-8 md:flex-row md:items-start" data-id="element-116" data-mp="36oxzr65apr0h">
        <div data-id="element-117" data-mp="3ufa5qbgzddof">
          <p className="display-title text-4xl text-white" data-id="element-118" data-mp="3uesbfkdvp9j5">CNS</p>
          <p className="text-[11px] uppercase tracking-[2px]" data-id="element-119" data-mp="3ud7ifz77pyne">Celulares Nuevos Saavedra</p>
          <p className="mt-4" data-id="element-120" data-mp="36mr0ed8wopu">Tu iPhone, Tu Estudio · CNS Digital</p>
        </div>
        <ul className="list-none space-y-2 p-0" data-id="element-121" data-mp="3le2jirrqo3ap">
          <li data-id="element-122" data-mp="3qcxaigzv0y5w">
            <a href={offer.instagramUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-white transition-colors duration-150 ease-out hover:text-gold" data-id="element-123" data-mp="3qcdsl0a7m9rv">
              <InstagramIcon className="h-4 w-4" aria-hidden="true" data-id="element-124" data-mp="3l9k6jf1oprec" />
              @celularesnuevossaavedra
            </a>
          </li>
          {offer.contactEmail && <li data-id="element-125" data-mp="3gcjzb0t3miln">
              <a href={`mailto:${offer.contactEmail}`} className="inline-flex items-center gap-2 text-white hover:text-gold" data-id="element-126" data-mp="3v7q63q00qlg1">
                <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-127" data-mp="3q83pr7ow8p30" />
                {offer.contactEmail}
              </a>
            </li>}
          {offer.whatsapp && <li className="inline-flex items-center gap-2 text-white" data-id="element-128" data-mp="3474tnw649z9">
              <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-129" data-mp="31uqrltj6jrh" />
              {offer.whatsapp}
            </li>}
        </ul>
        <div className="md:text-right" data-id="element-130" data-mp="ct78hklm7tjs">
          <p data-id="element-131" data-mp="cuil89x1gbn1">Guía independiente. No es una publicación oficial de Apple.</p>
          <p data-id="element-132" data-mp="qujkjkxnnb0e">iPhone es una marca registrada de Apple Inc.</p>
          <p className="mt-2" data-id="element-133" data-mp="mrwmh2ae4tur">© {year} CNS Digital.</p>
        </div>
      </div>
    </footer>;
}